import { alpha } from "@mui/material/styles";

// ----------------------------------------------------------------------

// SETUP COLORS
const GREY = {
	0: "#fff",
	100: "#FDFDFD",
	200: "#ECF1F6",
	300: "#E3E9ED",
	400: "#D1D8DD",
	500: "#BFC6CC",
	600: "#9CA4AB",
	700: "#78828A",
	800: "#66707A",
	850: "#667085",
	900: "#434E58",
	950: "#544F53",
	1000: "#171725",
	1100: "#000",
	1150: "#030712",
};

const PRIMARY = {
	lighter: "#F2F5F1",
	light: "#E4EBE3",
	main: "#789B73",
	dark: "#D7E1D5",
	darker: "#C9D7C7",
	contrastText: "#BBCDB9",
	beige: "#F2EEDE"
};

const SECONDARY = {
	lighter: "#DAD2F1",
	light: "#C2B8E3",
	main: "#22031F",
	dark: "#AEA0DD",
	darker: "#9786D0",
	contrastText: "#5A4C88",
};

const INFO = {
	lighter: "#D0F2FF",
	light: "#74CAFF",
	main: "#1890FF",
	dark: "#0C53B7",
	darker: "#04297A",
	contrastText: "#fff",
};

const SUCCESS = {
	lighter: "#F2F5F1",
	light: "#E4EBE3",
	main: "#789B73",
	dark: "#D7E1D5",
	darker: "#C9D7C7",
	contrastText: "#BBCDB9",
};

const WARNING = {
	lighter: "#FFF7CD",
	light: "#FFE16A",
	midLight: "#F59E0B",
	main: "#DC6803",
	dark: "#B78103",
	darker: "#7A4F01",
	contrastText: GREY[800],
};

const ERROR = {
	lighter: "#FFE7D9",
	light: "#F25F5C",
	main: "#B42318",
	dark: "#B72136",
	darker: "#7A0C2E",
	contrastText: "#fff",
};

const palette = {
	common: { black: "#ddd", white: "#eee" },
	primary: PRIMARY,
	secondary: SECONDARY,
	info: INFO,
	success: SUCCESS,
	warning: WARNING,
	error: ERROR,
	grey: GREY,
	divider: alpha(GREY[500], 0.24),
	text: {
		primary: GREY[800],
		secondary: GREY[600],
		disabled: GREY[500],
	},
	background: {
		paper: "#fff",
		default: GREY[100],
		neutral: GREY[200],
	},
	action: {
		active: GREY[600],
		hover: alpha(GREY[500], 0.08),
		selected: alpha(GREY[500], 0.16),
		disabled: alpha(GREY[0], 1),
		disabledBackground: alpha(GREY[600], 1),
		focus: alpha(GREY[500], 0.24),
		hoverOpacity: 0.08,
		disabledOpacity: 0.48,
	},
	shadesSecondary2 : '#F5F2E8',
	shadesSecondary2_hover : '#DCD9D0',
	tooltipBgPrimary: '#2F2F2F',
	borderPrimary: '#D0D5DD',
	greyBorder: '#CCCCCC',
};

export const MESSAGES_LOGO_COLORS = {
	lightBlue: '#DBEAFE',
	lightRed: '#FEE2E2',
	lightPurple: '#F3E8FF',
	lightGreen: '#DCFCE7',
	lightYellow: '#FEF9C3',
}

export const AVATAR_TEXT_COLORS: Record<string, string> = {
  '#DBEAFE': '#1E40AF', // Blue text for blue background
  '#FEE2E2': '#991B1B', // Red text for red background
  '#F3E8FF': '#6B21A8', // Purple text for purple background
  '#DCFCE7': '#166534', // Green text for green background
  '#FEF9C3': '#854D0E', // Yellow/brown text for yellow background
  '#E0F2FE': '#0369A1', // Light blue text for light blue background
  '#FEF3C7': '#92400E', // Light yellow text for light yellow background
  '#ECFDF5': '#065F46', // Light green text for light green background
  '#FFF1F2': '#BE185D', // Light pink text for light pink background
  '#FECACA': '#DC2626', // Red variations
  '#FED7D7': '#B91C1C',
  '#FDE68A': '#D97706',
  '#D9F99D': '#65A30D',
  '#A7F3D0': '#059669',
  '#BFDBFE': '#2563EB',
  '#DDD6FE': '#7C3AED',
  '#FECDD3': '#E11D48',
};


export const SENDBIRD_MENTION_BACKGROUND_LOGO_COLORS = {
	lightRed: '#FEE2E2',
	lightYellow: '#FEF3E2',
	lightBlue: '#DBEAFE',
	lightPurple: '#F3E8FF',
	lightGreen: '#DCFCE7',
}

export const SENDBIRD_MENTION_TEXT_COLORS: Record<string, string> = {
  '#FEE2E2': '#991B1B',
  '#FEF3E2': '#FAAB31',
  '#DBEAFE': '#1E40AF', // Blue text for blue background
  '#F3E8FF': '#6B21A8', // Purple text for purple background
  '#DCFCE7': '#166534', // Green text for green background
};

export default palette;
